import React, { useEffect, useState, useRef } from "react";
import { FaEdit, FaEye } from "react-icons/fa";
import apiRoutes from "../../../api/apiRoutes";
import VerVehiculosTar from "./VerVehiculosTar";
import FiltroVehiculosConTarjeta from "./FiltroVehiculosConTarjeta";
import EditarVehiculo from "./EditarVehiculo";
import useEscClose from "../../useEscClose";
import { appFetchJson } from "../../../utils/http";

// ¿hay filtros activos?
const hasActive = (f) => {
  if (!f) return false;
  if (f?.clienteId != null || f?.cliente?.id != null) return true;
  if (typeof f?.patente === "string" && f.patente.trim()) return true;
  if (typeof f?.descripcionKey === "string" && f.descripcionKey.trim())
    return true; // clave normalizada
  if (Array.isArray(f?.vehiculoIds) && f.vehiculoIds.length > 0) return true; // compat
  if (f?.marcaId != null || f?.marca?.id != null) return true;
  return false;
};

// flags para comparar “antes vs. después”
const activeFlags = (f) => ({
  cli: f?.clienteId != null || f?.cliente?.id != null,
  pat: !!(f?.patente && f.patente.trim()),
  dkey: !!(f?.descripcionKey && f.descripcionKey.trim()), // clave
  veh: Array.isArray(f?.vehiculoIds) && f.vehiculoIds.length > 0, // compat
  mar: f?.marcaId != null || f?.marca?.id != null,
});

// ¿la foto nueva representa **eliminación** (y no adición)?
const isRemovalChange = (prev, next) => {
  const p = activeFlags(prev);
  const n = activeFlags(next);
  const anyRemoved =
    (p.cli && !n.cli) ||
    (p.pat && !n.pat) ||
    (p.dkey && !n.dkey) ||
    (p.veh && !n.veh) ||
    (p.mar && !n.mar);
  const anyAdded =
    (!p.cli && n.cli) ||
    (!p.pat && n.pat) ||
    (!p.dkey && n.dkey) ||
    (!p.veh && n.veh) ||
    (!p.mar && n.mar);
  return anyRemoved && !anyAdded;
};

function VehiculosConTarjeta() {
  const [vehiculos, setVehiculos] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [mostrarFiltros, setMostrarFiltros] = useState(false);
  useEscClose(() => {
    setMostrarFiltros(false);
    document.activeElement?.blur();
  }, mostrarFiltros);

  // “en edición”
  const [filtros, setFiltros] = useState({
    cliente: null,
    clienteNombre: "",
    clienteId: null,
    patente: "",
    descripcion: "",
    descripcionKey: "", // NUEVO
    vehiculoIds: null, // compat
    marca: null,
    marcaId: null,
    marcaNombre: "",
  });

  // APLICADOS
  const VACIO = {
    cliente: null,
    clienteNombre: "",
    clienteId: null,
    patente: "",
    descripcion: "",
    descripcionKey: "", // NUEVO
    vehiculoIds: null, // compat
    marca: null,
    marcaId: null,
    marcaNombre: "",
  };
  const [aplicados, setAplicados] = useState(VACIO);

  // paginación
  const [paginaActual, setPaginaActual] = useState(1);
  const [vehiculosPorPagina, setVehiculosPorPagina] = useState(30);
  const [totalVehiculosBackend, setTotalVehiculosBackend] = useState(0);
  const [totalPaginasBackend, setTotalPaginasBackend] = useState(1);

  // modales
  const [showVehiculo, setShowVehiculo] = useState(false);
  useEscClose(() => {
    setShowVehiculo(false);
    document.activeElement?.blur();
  }, showVehiculo);

  const [showEditVehiculo, setShowEditVehiculo] = useState(false);
  useEscClose(() => {
    setShowEditVehiculo(false);
    document.activeElement?.blur();
  }, showEditVehiculo);

  const [vehiculoSeleccionado, setVehiculoSeleccionado] = useState(null);
  const LIST_URL = apiRoutes?.vehiculosConTarjeta?.list || null;

  const MOCK = [
    {
      id: 1,
      cliente: "SIGMA SRL",
      patente: "AAMP901",
      modelo: "VITZ",
      marca: "TOYOTA",
    },
    {
      id: 2,
      cliente: "SIGMA SRL",
      patente: "NBL439",
      modelo: "FUNCARGO",
      marca: "TOYOTA",
    },
    {
      id: 3,
      cliente: "SIGMA SRL",
      patente: "AAJ872",
      modelo: "RACTIS",
      marca: "TOYOTA",
    },
    {
      id: 4,
      cliente: "INMOBILIARIA RAICES SA",
      patente: "INA372",
      modelo: "RENEGADE SPORT",
      marca: "JEEP",
    },
    {
      id: 5,
      cliente: "TECNODEL SA CONSTRUCTORA",
      patente: "AAVG993",
      modelo: "ZS COM",
      marca: "MG",
    },
  ];

  const fetchVehiculos = async (
    pagina = paginaActual,
    size = vehiculosPorPagina,
    filtrosArg = aplicados,
  ) => {
    setCargando(true);

    if (!LIST_URL) {
      setVehiculos(MOCK);
      setTotalVehiculosBackend(MOCK.length);
      setTotalPaginasBackend(1);
      setCargando(false);
      return;
    }

    try {
      const qs = new URLSearchParams();
      qs.append("page", String(pagina - 1)); // backend 0-based
      qs.append("size", String(size));

      // clienteId
      const clienteId =
        filtrosArg?.clienteId ??
        filtrosArg?.cliente?.id ??
        (typeof filtrosArg?.cliente === "number" ? filtrosArg.cliente : null);
      if (clienteId != null) qs.append("clienteId", String(clienteId));

      // patente
      const patente = (filtrosArg?.patente || "").trim();
      if (patente) qs.append("patente", patente);

      // CLAVE normalizada (principal)
      const descripcionKey = (filtrosArg?.descripcionKey || "").trim();
      if (descripcionKey) qs.append("descripcionKey", descripcionKey);

      // compat: si aún vinieran IDs
      const vehiculoIds = Array.isArray(filtrosArg?.vehiculoIds)
        ? filtrosArg.vehiculoIds
        : null;
      if (!descripcionKey && vehiculoIds && vehiculoIds.length) {
        qs.append("vehiculoIds", vehiculoIds.join(","));
      }

      // marcaId
      const marcaId =
        filtrosArg?.marcaId ??
        filtrosArg?.marca?.id ??
        (typeof filtrosArg?.marca === "number" ? filtrosArg.marca : null);
      if (marcaId != null) qs.append("marcaId", String(marcaId));

      const data = await appFetchJson(`${LIST_URL}?${qs.toString()}`);

      const items = Array.isArray(data?.items) ? data.items : [];
      const totalElements =
        data?.totalElements ?? data?.total ?? items.length ?? 0;
      const totalPages = data?.totalPages ?? 1;
      const backendSize = data?.size ?? size;

      const normalizados = items.map((row, idx) => ({
        id: row.id ?? idx,
        cliente:
          row.clienteNombre ??
          row.cliente ??
          row.nombreCliente ??
          row.razonSocial ??
          "-",
        patente: row.patente ?? row.placa ?? row.matricula ?? "-",
        modelo:
          row.descripcionModelo ??
          row.modelo ??
          row.descripcion ??
          row.descricaoDetalles ??
          row.descripcionModel ??
          "-",
        marca: row.marcaNombre ?? row.marca ?? "-",
      }));

      setVehiculos(normalizados);
      setVehiculosPorPagina(backendSize);
      setTotalVehiculosBackend(totalElements);
      setTotalPaginasBackend(Math.max(1, totalPages));
    } catch (err) {
      console.error("Error cargando vehículos:", err);
      setVehiculos(MOCK);
      setVehiculosPorPagina(30);
      setTotalVehiculosBackend(MOCK.length);
      setTotalPaginasBackend(1);
    } finally {
      setCargando(false);
    }
  };

  // evitar doble fetch en dev
  const mountedOnce = useRef(false);
  useEffect(() => {
    if (mountedOnce.current) return;
    mountedOnce.current = true;
    fetchVehiculos(1, vehiculosPorPagina, aplicados);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // helpers UI
  const totalPaginas =
    totalPaginasBackend ||
    Math.ceil(totalVehiculosBackend / Math.max(1, vehiculosPorPagina)) ||
    1;
  const startIndex = (paginaActual - 1) * vehiculosPorPagina;
  const endIndex = Math.min(
    startIndex + vehiculosPorPagina,
    totalVehiculosBackend,
  );
  const datosAMostrar = vehiculos;
  const indiceInicio = totalVehiculosBackend === 0 ? 0 : startIndex + 1;
  const indiceFin = endIndex;

  const cambiarPagina = (num) => {
    const max = Math.max(1, totalPaginas);
    const target = Math.min(Math.max(1, num), max);
    setPaginaActual(target);
    fetchVehiculos(target, vehiculosPorPagina, aplicados);
  };

  const manejarCambioCantidad = (e) => {
    const nuevaCantidad = Number(e.target.value);
    setVehiculosPorPagina(nuevaCantidad);
    setPaginaActual(1);
    fetchVehiculos(1, nuevaCantidad, aplicados);
  };

  // aplicar filtros
  const aplicarFiltros = (f) => {
    const snap = hasActive(f) ? f : VACIO;
    setAplicados(snap);
    setFiltros(snap);
    setPaginaActual(1);
    fetchVehiculos(1, vehiculosPorPagina, snap);
  };

  const limpiarSeleccion = () => {
    setAplicados(VACIO);
    setFiltros(VACIO);
    setPaginaActual(1);
    fetchVehiculos(1, vehiculosPorPagina, VACIO);
  };

  const isFiltrosActivos = hasActive(aplicados);

  return (
    <div className="p-6 relative">
      <h1 className="page-title">💳 Vehículos con Tarjetas</h1>

      <div className="flex items-center gap-2 mb-4">
        <button
          onClick={() => setMostrarFiltros((v) => !v)}
          className="btn-fil"
        >
          {mostrarFiltros ? "Ocultar Filtros" : "Ver Filtros"}
        </button>

        {isFiltrosActivos && (
          <button onClick={limpiarSeleccion} className="btn-fil">
            Limpiar Selección
          </button>
        )}
      </div>

      {mostrarFiltros && (
        <FiltroVehiculosConTarjeta
          initialFilters={aplicados}
          onChangeFilters={(snap) => {
            if (!snap) return;
            if (isRemovalChange(aplicados, snap)) {
              const next = hasActive(snap) ? snap : VACIO;
              setAplicados(next);
              setFiltros(next);
              setPaginaActual(1);
              fetchVehiculos(1, vehiculosPorPagina, next);
            }
          }}
          onSubmit={(snap) => aplicarFiltros(snap)}
          onClose={() => setMostrarFiltros(false)}
        />
      )}

      <div className="control-block">
        <label htmlFor="cantidadPorPaginaVeh" className="label-strong">
          Mostrar por página:
        </label>
        <select
          id="cantidadPorPaginaVeh"
          value={vehiculosPorPagina}
          onChange={manejarCambioCantidad}
          className="select"
        >
          <option value={30}>30</option>
          <option value={40}>40</option>
          <option value={50}>50</option>
        </select>
      </div>

      {cargando ? (
        <div className="text-center text-gray-500">Cargando vehículos...</div>
      ) : (
        <>
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden">
              <thead className="bg-green-700 text-white">
                <tr>
                  <th className="px-4 py-2 text-left">Cliente</th>
                  <th className="px-4 py-2 text-left">N° de chapa</th>
                  <th className="px-4 py-2 text-left">Descripción/Modelo</th>
                  <th className="px-4 py-2 text-left">Marca</th>
                  <th className="px-4 py-2 text-center">Acción</th>
                </tr>
              </thead>
              <tbody>
                {datosAMostrar.map((v, idx) => (
                  <tr
                    key={`${v.id ?? v.patente ?? idx}-${idx}`}
                    className={idx % 2 === 0 ? "bg-gray-50" : "bg-white"}
                  >
                    <td className="px-4 py-2">{v.cliente}</td>
                    <td className="px-4 py-2">{v.patente}</td>
                    <td className="px-4 py-2">{v.modelo}</td>
                    <td className="px-4 py-2">{v.marca}</td>
                    <td className="px-4 py-2 text-center space-x-2">
                      <button
                        className="text-gray-600 hover:text-green-800"
                        title="Visualizar"
                        onClick={() => {
                          setVehiculoSeleccionado({ id: v.id });
                          setShowVehiculo(true);
                        }}
                      >
                        <FaEye />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {showVehiculo && (
            <div className="modal-backdrop">
              <div className="modal-panel-lg">
                <button
                  className="modal-close-x"
                  title="Cerrar"
                  onClick={() => setShowVehiculo(false)}
                >
                  &times;
                </button>
                <VerVehiculosTar
                  vehiculoId={vehiculoSeleccionado?.id}
                  onClose={() => setShowVehiculo(false)}
                />
              </div>
            </div>
          )}

          {showEditVehiculo && (
            <div className="modal-backdrop">
              <div className="modal-panel-lg">
                <button
                  className="modal-close-x"
                  title="Cerrar"
                  onClick={() => setShowEditVehiculo(false)}
                >
                  &times;
                </button>
                <EditarVehiculo
                  id={vehiculoSeleccionado?.id}
                  onClose={() => setShowEditVehiculo(false)}
                  onSaved={() =>
                    fetchVehiculos(paginaActual, vehiculosPorPagina, aplicados)
                  }
                />
              </div>
            </div>
          )}

          <div className="mt-4 text-sm text-gray-600">
            {`${totalVehiculosBackend.toLocaleString("es-ES")} item${totalVehiculosBackend !== 1 ? "s" : ""} encontrados, mostrando de ${indiceInicio} a ${indiceFin}.`}
          </div>

          <nav className="mt-2 flex justify-center space-x-1 text-gray-700">
            <button
              onClick={() => cambiarPagina(1)}
              disabled={paginaActual === 1}
              className={`px-2 py-1 rounded ${paginaActual === 1 ? "bg-gray-300 cursor-not-allowed" : "hover:bg-green-200"}`}
            >
              Primera
            </button>
            <button
              onClick={() => cambiarPagina(paginaActual - 1)}
              disabled={paginaActual === 1}
              className={`px-2 py-1 rounded ${paginaActual === 1 ? "bg-gray-300 cursor-not-allowed" : "hover:bg-green-200"}`}
            >
              Anterior
            </button>
            {[...Array(totalPaginas)].map((_, i) => {
              const num = i + 1;
              if (
                num === 1 ||
                num === totalPaginas ||
                (num >= paginaActual - 2 && num <= paginaActual + 2)
              ) {
                return (
                  <button
                    key={num}
                    onClick={() => cambiarPagina(num)}
                    className={`px-3 py-1 rounded ${paginaActual === num ? "bg-green-600 text-white" : "hover:bg-green-200"}`}
                  >
                    {num}
                  </button>
                );
              }
              if (num === paginaActual - 3 || num === paginaActual + 3)
                return (
                  <span key={num} className="px-2 py-1">
                    ...
                  </span>
                );
              return null;
            })}
            <button
              onClick={() => cambiarPagina(paginaActual + 1)}
              disabled={paginaActual === totalPaginas}
              className={`px-2 py-1 rounded ${paginaActual === totalPaginas ? "bg-gray-300 cursor-not-allowed" : "hover:bg-green-200"}`}
            >
              Próxima
            </button>
            <button
              onClick={() => cambiarPagina(totalPaginas)}
              disabled={paginaActual === totalPaginas}
              className={`px-2 py-1 rounded ${paginaActual === totalPaginas ? "bg-gray-300 cursor-not-allowed" : "hover:bg-green-200"}`}
            >
              Última
            </button>
          </nav>
        </>
      )}
    </div>
  );
}

export default VehiculosConTarjeta;
